document.addEventListener('DOMContentLoaded', function () {

  const customSwatches = {
    'jade':      '#56bba1',
    'tangerine': '#F28500',
    'turquiose': '#93cbc9',
    'ocean':     '#3673C4',
    'windowpane': '#070372ff'}

    


    


    

  

  document.querySelectorAll('.product-form__controls-group label.color-swatch').forEach(label => {
    const swatchColor = getComputedStyle(label).getPropertyValue('--swatch-color').trim().toLowerCase();
    
    if (customSwatches[swatchColor]) {
      label.style.setProperty('--swatch-color', customSwatches[swatchColor]);
    }
  });

});